// extracted by mini-css-extract-plugin
export default {"Logo":"AdminSidebar_Logo__VVLEo"};